import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../TrueGrit";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGritGameMode} from "../server/TrueGritGameMode";
import {gsap} from "gsap";
import {MathUtils} from "../utils/MathUtils";

/**
 * Created by Jerker Nord on 2021-09-13.
 */

export class TrueGritReelBackgroundView extends PIXI.Container implements StageLayer {

    private static REEL_BACKGROUND_POSITION:PIXI.Point = new PIXI.Point(354, 390);

    private _reelBackgroundMainGame:PIXI.Sprite;
    private _reelBackgroundFS:PIXI.Sprite;
    private _reelBackgroundSuperFS:PIXI.Sprite;
    private _fadeInTimeline:gsap.core.Timeline;

    // #105
    private _bulletHoles: PIXI.Sprite[][] = [];
    private _bulletHolesContainer: PIXI.Container;

    constructor() {
        super();
        this.name = "TrueGritReelBackgroundView";
        this.init();
    }

    private init() {
        this._reelBackgroundMainGame = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.REEL_BACKGROUND)[0]);
        this._reelBackgroundMainGame.position = TrueGritReelBackgroundView.REEL_BACKGROUND_POSITION;
        this._reelBackgroundMainGame.anchor.set(0.5, 0.5);
        this.addChild(this._reelBackgroundMainGame);

        this._reelBackgroundFS = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.REEL_BACKGROUND_FS)[0]);
        this._reelBackgroundFS.position = TrueGritReelBackgroundView.REEL_BACKGROUND_POSITION;
        this._reelBackgroundFS.anchor.set(0.5, 0.5);
        this._reelBackgroundFS.alpha = 0;
        this.addChild(this._reelBackgroundFS);

        this._reelBackgroundSuperFS = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.REEL_BACKGROUND_SUPER_FS)[0]);
        this._reelBackgroundSuperFS.position = TrueGritReelBackgroundView.REEL_BACKGROUND_POSITION;
        this._reelBackgroundSuperFS.anchor.set(0.5, 0.5);
        this._reelBackgroundFS.alpha = 0;
        this.addChild(this._reelBackgroundFS);

        // #105
        this._bulletHolesContainer = new PIXI.Container();
        let bulletHole: PIXI.Sprite,
            reelSymHeight: number;
        for (let i: number = 0; i < 6; i++) {
            const subBulletHoles: PIXI.Sprite[] = [];
            reelSymHeight = 4;
            if (i > 0 && i < 4) {
                reelSymHeight = 5;
            }
            for (let j: number = 0; j < reelSymHeight; j++) {
                bulletHole = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("bulletHole")[0]);
                bulletHole.anchor.set(0.5);
                bulletHole.visible = false;
                bulletHole.rotation = MathUtils.randomIntFromInterval(0, 180);

                this._bulletHolesContainer.addChild(bulletHole);
                subBulletHoles.push(bulletHole);
            }
            this._bulletHoles.push(subBulletHoles);
        }
        this.addChild(this._bulletHolesContainer);

        this.onResize();
    }

    onResize():void {
        this.position.set(0, 0);
        this._bulletHolesContainer.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    private swapReelBackgroundTo(newBackground:PIXI.Sprite, fadeInTime:number) {
        this._fadeInTimeline = new gsap.core.Timeline();
        this._fadeInTimeline.add(() => {newBackground.alpha = 0});
        this._fadeInTimeline.add(() => {
            this.addChild(newBackground);
            this.addChild(this._bulletHolesContainer);
        });
        this._fadeInTimeline.add(gsap.to(newBackground, {duration : 1, alpha : 1}));
        this._fadeInTimeline.add(() => {
            for(let i:number = 0; i < this.children.length - 2; i++) {
                this.children[i].alpha = 0;
            }
        })
    }

    public setMode(mode:string, fadeInTime:number = 0) {
        if(mode == TrueGritGameMode.FREESPIN || mode == TrueGritGameMode.FREESPIN_AVALANCHE) {
            this.swapReelBackgroundTo(this._reelBackgroundFS, fadeInTime);
        } else if(mode == TrueGritGameMode.FREESPIN_SUPER || (mode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE)) {
            this.swapReelBackgroundTo(this._reelBackgroundSuperFS, fadeInTime);
        } else {
            this.swapReelBackgroundTo(this._reelBackgroundMainGame, fadeInTime);
        }
    }

    // #105
    public turnOnBulletHole(reel: number, row: number, scaleX: number, xOffset: number, yOffset: number): void {
        const bulletHole: PIXI.Sprite = this._bulletHoles[reel][row],
            offset: PIXI.Point = new PIXI.Point(50, 75),
            topReelOffset: PIXI.Point = new PIXI.Point(50, -45);

        bulletHole.scale.x = scaleX;
        bulletHole.position = offset;
        if (reel > 0 && reel < 4) {
            bulletHole.position = topReelOffset;
        }
        bulletHole.position.x += (reel * TrueGritStatics.symbolWidth) + xOffset;
        bulletHole.position.y += (row * TrueGritStatics.symbolHeight) + yOffset;
        bulletHole.rotation = MathUtils.randomIntFromInterval(0, 180);
        bulletHole.visible = true;
    }

    // #105
    public turnOffAllTheBulletHoles(): void {
        this._bulletHoles.forEach((holes: PIXI.Sprite[]) => {
            holes.forEach((hole: PIXI.Sprite) => {
                hole.visible = false;
            });
        });
    }
}